<div class="auth-wrapper auth-v2 bg-light">
  <div
    class="auth-inner row m-0 justify-content-center align-items-center vh-100"
  >
    <div class="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
      <div class="card shadow-sm border-0 rounded-4 p-4">
        <!-- Logo -->
        <div class="text-center mb-3">
          <img
            src="/images/osquare.png"
            alt="OSquare"
            width="200"
            height="auto"
            class="mb-4 mx-auto d-block"
          />
        </div>

        <h3 class="card-title text-center font-weight-bold mb-2">
          Reset Password
        </h3>
        <p class="card-text text-center mb-4 text-muted">
          Choose a new password and you’ll be back in no time.
        </p>

        <form
          class="auth-reset-password-form"
          [formGroup]="form"
          (ngSubmit)="onSubmit()"
        >
          <!-- New Password -->
          <div class="form-group mb-3">
            <label>New Password</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                class="form-control"
                placeholder="············"
                autofocus
                [ngClass]="{
                  'is-invalid': password?.touched && password?.errors,
                }"
              />

              <span
                class="input-group-text cursor-pointer"
                (click)="togglePasswordTextType()"
              >
                <i
                  class="bi"
                  [ngClass]="passwordTextType ? 'bi-eye-slash' : 'bi-eye'"
                ></i>
              </span>
            </div>

            <div *ngIf="password?.touched" class="text-danger small mt-1">
              <div *ngIf="password?.errors?.['required']">
                This field is required
              </div>
              <div *ngIf="password?.errors?.['pattern']">
                Password must contain uppercase, lowercase, number, and special
                character
              </div>
            </div>
          </div>

          <!-- Confirm Password -->
          <div class="form-group mb-5">
            <label>Confirm Password</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="confPasswordTextType ? 'text' : 'password'"
                formControlName="confPassword"
                class="form-control"
                placeholder="············"
                [ngClass]="{
                  'is-invalid':
                    confPassword?.touched &&
                    (confPassword?.errors ||
                      form?.errors?.['passwordMismatch']),
                }"
              />

              <span
                class="input-group-text cursor-pointer"
                (click)="toggleConfPasswordTextType()"
              >
                <i
                  class="bi"
                  [ngClass]="confPasswordTextType ? 'bi-eye-slash' : 'bi-eye'"
                ></i>
              </span>
            </div>

            <div *ngIf="confPassword?.touched" class="text-danger small mt-1">
              <div *ngIf="confPassword?.errors?.['required']">
                This field is required
              </div>
              <div *ngIf="form?.errors?.['passwordMismatch']">
                Passwords do not match
              </div>
            </div>
          </div>

          <button class="btn btn-primary w-100" [disabled]="loading">
            Set New Password
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
